import { WatchAlert } from '@compumark/order-management-client';

export function toWatchAlertRequestDTO(wa: WatchAlert): any {
  return {
    alertName: wa.alertName ?? '',
    contactId: wa.contactId ?? 0,
    subject: wa.subject ?? '',
    cc: wa.cc ?? [],
    bcc: wa.bcc ?? [],
    products: Array.isArray(wa.products)
      ? wa.products.map((p: any) =>
          typeof p === 'object'
            ? { productId: p.productId, productCode: p.productCode }
            : { productId: p },
        )
      : [],
    frequency: wa.frequency ?? undefined,
    hitOverView: wa.hitOverView ?? undefined,
    orders: Array.isArray(wa.orders)
      ? wa.orders.map((o) => (o != null ? String(o) : ''))
      : [],
    disableSelfReceipt: wa.disableSelfReceipt ?? false,
    defaultSubject: wa.defaultSubject ?? false,
    title: wa.title ?? '',
    clientReference: wa.clientReference ?? [],
    subClientReference: wa.subClientReference ?? [],
  };
}
